<script>
import moment from "moment";

    import { get, writable } from "svelte/store";
import AppStore from "../../AppStore";
import AuthStore from "../../Auth/Store";
    import Feature from "../../Branding/Feature";
    import User from "../../Branding/User";
import ColorHelper from "../../Helpers/ColorHelper";
import roundFloat from "../../Helpers/Misc/roundFloat";
import StringHelper from "../../Helpers/StringHelper";
import MapStore from "../../Map/Store";
import ModelType from "../../Models/ModelType";
    import Vessel from "../../Models/Vessel";
import Router from "../../Router";
    import Flag from '../Flag.svelte';
import InfoCardStore from "./Store";

    export let vessel = writable(null);
    let model = vessel;

    let lastUpdated = InfoCardStore.meta.lastUpdated;
    
    let timeSliderValue = writable(0);
	let timeSliderValueMax = writable(0);
    let vesselHistoricPathStopIndex = -1;
	let vesselHistoricPathStopLength = -1;

    let startTimePointIndex = -1;
    let endTimePointIndex = -1;

    let imo, mmsi, name, timestamp, type, flag, draught, course, speedKnots, destination, eta, localtime, alertTypes, nameOrFlagChangedTimestamp, snapshot;
    flag = "";

    let altitudeFt, altitudeBaro, sil, nacp;

    let hasTimeSlider = false;
	$: {
		$lastUpdated;
		hasTimeSlider = User.hasFeature(Feature.TIME_SLIDER.VIEW);
    }

    $: {
		$timeSliderValue;
		$timeSliderValueMax;
		// $vessel.group.timeSlider.value;
		if ($vessel) {
			timeSliderValue = $vessel.group.timeSliderData.value;
			timeSliderValueMax = $vessel.group.timeSliderData.max;

            // Vessel assets
			imo = $vessel.imo;
			mmsi = $vessel.mmsi;
			name = $vessel.name;
			timestamp = $vessel.timestamp;
			type = $vessel.classification;
			flag = $vessel.flag;
			draught = $vessel.draught;
			course = $vessel.course;
			speedKnots = $vessel.speedKnots;
			destination = $vessel.voyageDestination;
			eta = $vessel.voyageEta;
			localtime = $vessel.localTime;
			alertTypes = $vessel.alertTypes;
			nameOrFlagChangedTimestamp = $vessel.nameOrFlagChangedTimestamp;
			snapshot = $vessel.hasActiveSnapshot();

            if (snapshot) {
				mmsi = $vessel.snapshotMmsi;
				timestamp = $vessel.snapshotTimestamp;
				flag = $vessel.snapshotFlag;
				course = ($vessel.snapshotCourse == null)?"Unknown":$vessel.snapshotCourse;
				speedKnots = $vessel.snapshotSpeedKnots;
				localtime = $vessel.snapshotLocalTime;
			}

            // Aircraft assets
            altitudeFt = $vessel.altitude;
            altitudeBaro = $vessel.altitudeBaro;
            sil = $vessel.sil;
            nacp = $vessel.nacp;
            if (snapshot) {
                altitudeFt = $vessel.snapshotAltitude;
                altitudeBaro = $vessel.snapshotAltitudeBaro;
                sil = $vessel.snapshotSil;
                nacp = $vessel.snapshotNacp;
            }


			vesselHistoricPathStopIndex = -1;
			vesselHistoricPathStopLength = -1;
			if ($vessel.historicPath !== null) {
				vesselHistoricPathStopIndex = $vessel.historicPath.stops.getIndexForTimestamp(timestamp);
				vesselHistoricPathStopLength = $vessel.historicPath.stops.length;

                startTimePointIndex = 0;
                endTimePointIndex = vesselHistoricPathStopLength - 1;
                if ($vessel.historicPath.config.historicOrder === 1) {
                    startTimePointIndex = vesselHistoricPathStopLength - 1;
                    endTimePointIndex = 0;
                }
			}

            
			// console.log('info card updated', vesselHistoricPathStopIndex, vesselHistoricPathStopLength, snapshot)
			// console.log('vessel', $vessel);
			// console.log("$timeSliderValue", $timeSliderValue, "$timeSliderValueMax", $timeSliderValueMax, $timeSliderValue == $timeSliderValueMax);
		}
	}

    let gotoOldest = (e) => {
		if (!e.target.classList.contains("enabled")) { return; }
        
        if ($vessel.historicPath.config.historicOrder === -1) {
		    $timeSliderValue = moment($vessel.historicPath.stops.getTimestampForIndex(0));
        } 
        else if ($vessel.historicPath.config.historicOrder === 1) {
            $timeSliderValue = moment($vessel.historicPath.stops.getTimestampForIndex($vessel.historicPath.stops.length-1));
        }

		$lastUpdated = Date.now();
	};
	let gotoPrev = (e) => {
		if (!e.target.classList.contains("enabled")) { return; }

		const index = $vessel.historicPath.stops.getIndexForTimestamp(timestamp);
        let nextIndex = index - 1;
        if ($vessel.historicPath.config.historicOrder === 1) {
            nextIndex = index + 1;
        }
		const ts = $vessel.historicPath.stops.getTimestampForIndex(nextIndex);
		$timeSliderValue = moment(ts);
		$lastUpdated = Date.now();
	};
	let gotoNext = (e) => {
		if (!e.target.classList.contains("enabled")) { return; }
		const index = $vessel.historicPath.stops.getIndexForTimestamp(timestamp);
        let nextIndex = index + 1;
        if ($vessel.historicPath.config.historicOrder === 1) {
            nextIndex = index - 1;
        }
		const ts = $vessel.historicPath.stops.getTimestampForIndex(nextIndex);
		$timeSliderValue = moment(ts);
		$lastUpdated = Date.now();
	};
	let gotoNewest = (e) => {
		if (!e.target.classList.contains("enabled")) { return; }

        if ($vessel.historicPath.config.historicOrder === -1) {
		    $timeSliderValue = moment($vessel.historicPath.stops.getTimestampForIndex($vessel.historicPath.stops.length-1));
        } 
        else if ($vessel.historicPath.config.historicOrder === 1) {
            $timeSliderValue = moment($vessel.historicPath.stops.getTimestampForIndex(0));
        }
		$lastUpdated = Date.now();
	};
	let resetSlider = (e) => {
		if (!e.target.classList.contains("enabled")) { return; }
		$timeSliderValue = $timeSliderValueMax;
		$lastUpdated = Date.now();
	}

    

</script>
{#if $vessel.type === ModelType.AIRCRAFT}
    <ul>
        <li>
            <div>ICAO Address:</div>
            <div>{Vessel.formatUndefined($model.icaoAddress)}</div>
        </li>
        <li>
            <div>Registration:</div>
            <div>{Vessel.formatUndefined($model.registration)}</div>
        </li>
        <li>
            <div>Timestamp:{#if vesselHistoricPathStopIndex !== -1 && hasTimeSlider}<br/>&nbsp;{/if}</div>
            <div>
                <span title={timestamp}>{Vessel.formatTime(timestamp)}</span>
                <span class='time-nav-links' class:displaynone={!(vesselHistoricPathStopIndex !== -1 && hasTimeSlider)}>
                    <br/>
                    Go to:  <button on:click={gotoOldest} class:enabled={vesselHistoricPathStopIndex !== startTimePointIndex}>oldest</button>
                            | <button on:click={gotoPrev} class:enabled={vesselHistoricPathStopIndex !== startTimePointIndex}>prev</button>
                            | <button on:click={gotoNext} class:enabled={vesselHistoricPathStopIndex !== endTimePointIndex}>next</button>
                            | <button on:click={gotoNewest} class:enabled={vesselHistoricPathStopIndex !== endTimePointIndex}>latest</button>
                            {#if $timeSliderValue !== $timeSliderValueMax}
                                | <button on:click={resetSlider} class:enabled={$timeSliderValue !== $timeSliderValueMax}>reset</button>
                            {/if}
                </span>
            </div>
        </li>
        {#if typeof altitudeFt !== "undefined" && altitudeFt !== ""}
            <li>
                <div>Altitude:</div>
                <div>{Vessel.formatAltitude(altitudeFt)} (gnss)</div>
            </li>
        {/if}
        {#if typeof altitudeBaro !== "undefined" && altitudeBaro !== ""}
            <li>
                <div>Altitude:</div>
                <div>{Vessel.formatUndefined(altitudeBaro)} (baro)</div>
            </li>
        {/if}

        <li>
            <div>Call Sign:</div>
            <div>{Vessel.formatUndefined($model.callSign)}</div>
        </li>
        <li>
            <div>SIL:</div>
            <div>{Vessel.formatUndefined(sil)}</div>
        </li>
        <li>
            <div>NAC_P:</div>
            <div>{Vessel.formatUndefined(nacp)}</div>
        </li>
        <li>
            <div>Flight Number:</div>
            <div>{Vessel.formatUndefined($model.flightNumber)}</div>
        </li>
        <li>
            <div>Flight Operator:</div>
            <div>{Vessel.formatUndefined($model.flightOperator)}</div>
        </li>
        <li>
            <div>Equipment:</div>
            <div>{Vessel.formatUndefined($model.equipment)}</div>
        </li>
        {#if !!$model.originICAO}
            <li>
                <div>Origin (ICAO):</div>
                <div>{$model.originICAO}</div>
            </li>
        {/if}
        {#if !!$model.originIATA}
        <li>
            <div>Origin (IATA):</div>
            <div>{$model.originIATA}</div>
        </li>
        {/if}
        {#if !!$model.destinationICAO}
            <li>
                <div>Destination (ICAO):</div>
                <div>{$model.destinationICAO}</div>
            </li>
        {/if}
        {#if !!$model.destinationIATA}
            <li>
                <div>Destination (IATA):</div>
                <div>{$model.destinationIATA}</div>
            </li>
        {/if}
    </ul>
{:else if $vessel.type === ModelType.VESSEL}
    <ul>
        <li>
            <div>IMO:</div>
            <div>{Vessel.formatUndefined(imo)}</div>
        </li>
        <li>
            <div>MMSI:</div>
            <div>{Vessel.formatUndefined(mmsi)}</div>
        </li>
        <li>
            <div>Timestamp:{#if vesselHistoricPathStopIndex !== -1 && hasTimeSlider}<br/>&nbsp;{/if}</div>
            <div>
                <span title={timestamp}>{Vessel.formatTime(timestamp)}</span>
                <span class='time-nav-links' class:displaynone={!(vesselHistoricPathStopIndex !== -1 && hasTimeSlider)}>
                    <br/>
                    Go to:  <button on:click={gotoOldest} class:enabled={vesselHistoricPathStopIndex !== 0}>oldest</button>
                            | <button on:click={gotoPrev} class:enabled={vesselHistoricPathStopIndex !== 0}>prev</button>
                            | <button on:click={gotoNext} class:enabled={vesselHistoricPathStopIndex !== vesselHistoricPathStopLength-1}>next</button>
                            | <button on:click={gotoNewest} class:enabled={vesselHistoricPathStopIndex !== vesselHistoricPathStopLength-1}>latest</button>
                            {#if $timeSliderValue !== $timeSliderValueMax}
                                | <button on:click={resetSlider} class:enabled={$timeSliderValue !== $timeSliderValueMax}>reset</button>
                            {/if}
                </span>
            </div>
        </li>
        {#if nameOrFlagChangedTimestamp !== false}
            <li>
                <div>Static change:</div>
                <div>{Vessel.formatTime(nameOrFlagChangedTimestamp)}</div>
            </li>
        {/if}
        <li>
            <div>Alert:</div>
            <div>
                {#if !alertTypes || alertTypes.length == 0}
                    None
                {:else}
                    {Vessel.formatUndefined(alertTypes)}
                {/if}
            </div>
        </li>
        <li>
            <div>Type:</div>
            <div>{Vessel.formatUndefined(type)} {#if snapshot}(latest){/if}</div>
        </li>
        <li>
            <div>Flag:</div>
            <div><Flag cc={flag}/> {Vessel.formatUndefined(flag)}</div>
        </li>
        <li>
            <div>Draught:</div>
            <div>{Vessel.formatDraught(draught)} {#if snapshot}(latest){/if}</div>
        </li>
        <li>
            <div>Course:</div>
            <div>{course}</div>
        </li>
        <li>
            <div>Speed:</div>
            <div>{speedKnots}</div>
        </li>
        <li>
            <div>Destination:</div>
            <div>{destination} {#if snapshot}(latest){/if}</div>
        </li>
        <li>
            <div>ETA:</div>
            <div>{Vessel.formatTime(eta)} {#if snapshot}(latest){/if}</div>
        </li>
        <li>
            <div>Local Time:</div>
            <div>{@html localtime}</div>
        </li>
        {#if $vessel && $vessel.isSTS()}
            <li>
                <div>Ship-to-ship alerted with:</div>
                <div class='oa'>
                    <span class='time-nav-links'>
                    <button on:click={()=>{
                        let other = $vessel.getSTSPartner();
                        if (other === false) {
                            AppStore.snackbar.start("No Vessel found with this MMSI.", "error");
                        }
                        else {
                            $vessel.group.selectSingleVessel(other);
                            $lastUpdated = Date.now();
                        }

                    }} class:fl={true} class:enabled={true}>{$vessel.getSTSData().for}</button>

                    <button on:click={()=>{
                        let other = $vessel.getSTSPartner();
                        if (other === false) {
                            AppStore.snackbar.start("No Vessel found with this MMSI.", "error");
                        }
                        else {
                            Router.actions.gotoVesselHistoryForVessels([$vessel, other], 31, 0);
                        }

                    }} class:fl={true} class:enabled={true}>Check Vessel Histories</button>
                    <!-- <a href='/' on:click|preventDefault={}></a> -->
                </div>
            </li>
        {/if}
        {#if $vessel && $vessel.isRIM()}
            <li>
                <div>Risk Level:</div>
                <div class='oa' style={"font-weight:bold;color:"+ColorHelper.getRiskLevelColor($vessel.getRiskLevel())}>{$vessel.getRiskLevel()}</div>
            </li>
            {#if $vessel.hasStrikeData()}
                <li>
                    <div>Time to strike:</div>
                    <div class='oa' style={"color:"+ColorHelper.getRiskLevelColor($vessel.getRiskLevel())}>{StringHelper.formatMinutesAndSeconds($vessel.getStrikeData().mins_to_strike)} minutes</div>
                </li>
                <li>
                    <div>Distance to strike:</div>
                    <div class='oa' style={"color:"+ColorHelper.getRiskLevelColor($vessel.getRiskLevel())}>{$vessel.getStrikeData().distance_to_strike} metres</div>
                </li>
                <li>
                    <div>Location of Strike:</div>
                    <div class='oa'>
                        <a href="/" on:click|preventDefault={()=>{
                            MapStore.helpers.zoomToPoint([ $vessel.getStrikeData().lon, $vessel.getStrikeData().lat ]);
                        }}>
                            {StringHelper.formatLngLat($vessel.getStrikeData().lon, $vessel.getStrikeData().lat, get(AuthStore.session.user).lngLatFormat)}
                        </a>
                    </div>
                </li>
            {/if}
            {#if $vessel.extraData.type_classification}
                <li>
                    <div>Type Classification:</div>
                    <div class='oa'>
                        {StringHelper.ucfirst($vessel.extraData.type_classification)}
                        {#if $vessel.extraData.type_probability !== "na"}
                            ({roundFloat(parseFloat($vessel.extraData.type_probability)*100, 2)} %)
                        {/if}
                    </div>
                </li>
                <li>
                    <div>Activity Classification:</div>
                    <div class='oa'>
                        {$vessel.extraData.activity_classification}
                    </div>
                </li>
                {#if $vessel.extraData.type_classification === "trawler"}
                    <li>
                        <div>Fishing Speed:</div>
                        <div class='oa'>
                            {$vessel.extraData.fishing_speed} knots
                        </div>
                    </li>
                    <li>
                        <div>Steaming Speed:</div>
                        <div class='oa'>
                            {$vessel.extraData.steaming_speed} knots
                        </div>
                    </li>
                {/if}
            {/if}
        {/if}
    </ul>
{/if}